import i18n from "../../../i18n.config";

export type WhyMatchReasons = {
  sentimentHigh: boolean;
  journeyMatch: boolean;
  energyStyle: "high" | "calm" | null;
  matchedSkills: string[];
};

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

function journeyLabel(journeyType: string, t: TranslateFn): string {
  const key = `intake.results.journey_labels.${journeyType}`;
  const translated = t(key);
  return translated === key ? journeyType : translated;
}

export function buildWhyYouMatch(
  session: { journeyType: string },
  mentor: { name: string; title: string; industry: string },
  reasons: WhyMatchReasons,
  t: TranslateFn = (key, options) => i18n.t(key, options)
): string {
  const sentences: string[] = [];
  const firstName = mentor.name.split(" ")[0] || mentor.name;
  const journey = journeyLabel(session.journeyType, t);

  if (reasons.sentimentHigh && reasons.journeyMatch) {
    sentences.push(
      t("intake.results.why_templates.journey_sentiment", {
        journey,
        firstName,
        industry: mentor.industry,
      })
    );
  } else if (reasons.journeyMatch) {
    sentences.push(
      t("intake.results.why_templates.journey_only", {
        journey,
        firstName,
        title: mentor.title,
      })
    );
  } else if (reasons.sentimentHigh) {
    sentences.push(
      t("intake.results.why_templates.sentiment_only", { firstName })
    );
  }

  if (reasons.energyStyle === "high") {
    sentences.push(
      t("intake.results.why_templates.energy_high", { firstName })
    );
  } else if (reasons.energyStyle === "calm") {
    sentences.push(
      t("intake.results.why_templates.energy_calm", { firstName })
    );
  }

  if (reasons.matchedSkills.length > 0) {
    const skillList = reasons.matchedSkills.slice(0, 2).join(
      t("intake.results.why_templates.skills_joiner", { defaultValue: " and " })
    );
    sentences.push(
      t("intake.results.why_templates.skills", { skills: skillList, firstName })
    );
  }

  if (sentences.length === 0) {
    sentences.push(
      t("intake.results.why_templates.fallback", {
        firstName,
        industry: mentor.industry,
      })
    );
  }

  return sentences.slice(0, 3).join(" ");
}

export function badgeLabel(
  badge: "best_match" | "soul_match" | null,
  t: TranslateFn = (key, options) => i18n.t(key, options)
): string | null {
  if (!badge) return null;
  return t(`intake.results.badges.${badge}`);
}
